import {
  ClinicPaymentQuery,
  ClinicOrder,
  ListResult,
  Payment,
} from '../types';
import { delay } from './delay';
import { db } from './db';
import { ERR_NOT_FOUND } from './errors';
import { readUserIdFromToken } from './auth-utils';
import { getOrderOwner } from './orderMock';

const matches = (p: Payment, query: ClinicPaymentQuery): boolean => {
  if (query.status && p.status !== query.status) return false;
  if (query.keyword) {
    const keyword = query.keyword.trim().toLowerCase();
    if (keyword.length > 0) {
      if (!p.id.toLowerCase().includes(keyword) && !p.orderId.toLowerCase().includes(keyword)) {
        return false;
      }
    }
  }
  return true;
};

const findOrderForPayment = (orderId: string): ClinicOrder | undefined =>
  db.orders.find((o) => o.id === orderId);

export const paymentMock = {
  list: async (query: ClinicPaymentQuery = {}): Promise<ListResult<Payment>> => {
    await delay();
    const userId = readUserIdFromToken();
    const owned = db.payments.filter((p) => getOrderOwner(p.orderId) === userId);
    const filtered = owned.filter((p) => matches(p, query));
    const skip = query.skip ?? 0;
    const take = query.take ?? 0;
    const items = take === 0 ? filtered.slice(skip) : filtered.slice(skip, skip + take);
    return { items: items.map((p) => ({ ...p })), skip, take, total: filtered.length };
  },

  detail: async (paymentId: string): Promise<Payment> => {
    await delay();
    const userId = readUserIdFromToken();
    const payment = db.payments.find((p) => p.id === paymentId);
    if (!payment || getOrderOwner(payment.orderId) !== userId) {
      throw ERR_NOT_FOUND('Payment');
    }
    return { ...payment };
  },

  invoiceText: async (orderId: string): Promise<string> => {
    await delay();
    const userId = readUserIdFromToken();
    const order = findOrderForPayment(orderId);
    if (!order || getOrderOwner(order.id) !== userId) {
      throw ERR_NOT_FOUND('Order');
    }
    const lines = [
      `INVOICE — Clinic Portal (mock)`,
      `Order ID: ${order.id}`,
      `Created at: ${order.createdAt}`,
      ``,
      ...order.items.map(
        (i) =>
          `${i.productNameEn.padEnd(40)} ${String(i.quantity).padStart(4)} ${i.unit.padEnd(8)} ${i.unitPrice.toFixed(2)}  =  ${i.lineTotal.toFixed(2)}`,
      ),
      ``,
      `Subtotal: ${order.subtotal.toFixed(2)}`,
      `GST:      ${order.gstTotal.toFixed(2)}`,
      `Total:    ${order.total.toFixed(2)}`,
    ];
    return lines.join('\n');
  },
};
